module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-2-080824b098620a971860096ac6f02301.webp";